import { ChangeDetectionStrategy, Component, HostListener, Input } from '@angular/core';

import { VideogularComponent } from '../Videogular.Component';

import { IScrubAdapter } from './scrubAdapter/IScrubAdapter';

import styles from './VgChaptersMenu.module.less';

@Component({
	selector: 'vg-chapters-menu',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<ng-container *ngIf="vgApi.chapterHelper.currentChapter() as currentChapter">
			<button
				type="button"
				class="btn btn-transparent"
				[ngClass]="styles.headerContainer"
				[attr.aria-label]="showCompleteMenu ? translations.hideChapters : translations.showChapters"
				(click)="showCompleteMenu = !showCompleteMenu"
			>
				<div [ngClass]="styles.chapterHeading">
					@if (!currentChapter.isFakeInitialChapter) {
						<span class="type-bold">
							{{ translations.chapterNumber | VbUpdateTranslationParams : { '0': currentChapter.chapterIndex + 1 } }}:&nbsp;
						</span>
						<span>{{ currentChapter.title }}</span>
					} @else {
						{{ translations.selectChapter }}
					}
				</div>
				<span class="glyphicons" [ngClass]="showCompleteMenu ? 'chevron-down' : 'chevron-right'"></span>
			</button>
		</ng-container>

		@if (showCompleteMenu) {
			<div [ngClass]="styles.completeMenu">
				@for (chapter of vgApi.chapterHelper.chapters(); track chapter) {
					@if (!chapter.isFakeInitialChapter) {
						<button
							type="button"
							class="btn btn-transparent"
							[attr.aria-label]="translations.chapterNumber | VbUpdateTranslationParams : { '0': chapter.chapterIndex + 1 }"
							[ngClass]="[
								styles.menuItem,
								vgApi.chapterHelper.currentChapter().chapterIndex === chapter.chapterIndex ? styles.activeChapter: ''
							]"
							(click)="vgApi.seekTime(scrubAdapter.onScrubTime(chapter.time) / 1000)"
						>
							<div [ngClass]="styles.chapterHeading">
								<span class="type-bold">
									{{ translations.chapterNumber | VbUpdateTranslationParams : { '0': chapter.chapterIndex + 1 } }}:&nbsp;
								</span>
								<span>{{ chapter.title }}</span>
							</div>
						</button>
					}
				}
			</div>
		}
	`,
	host: {
		'[class]': 'styles.root'
	},
    standalone: false
})
export class VgChaptersMenuComponent {
	@Input() public translations: any;
	@Input() public scrubAdapter: IScrubAdapter;

	public readonly styles = styles;
	public showCompleteMenu: boolean = false;

	constructor(
		public vgApi: VideogularComponent
	) { }

	@HostListener('mouseenter')
	public onHostMouseEnter(): void {
		this.vgApi.forceVgControlsDisplay.set(true);
	}

	@HostListener('mousemove')
	public onHostMouseMove(): void {
		this.vgApi.forceVgControlsDisplay.set(true);
	}

	@HostListener('mouseleave')
	public onHostMouseLeave(): void {
		this.vgApi.forceVgControlsDisplay.set(false);
	}

	@HostListener('mouseout')
	public onHostMouseOut(): void {
		this.vgApi.forceVgControlsDisplay.set(false);
	}

}
